import { v7 as uuidv7 } from 'uuid';
import { INotificationGroup } from '../dtos/responses/notification-group.model';

const casesNotificationGroups: INotificationGroup[] = [
    {
        id: uuidv7(),
        name: 'cases'
    },
    {
        id: uuidv7(),
        name: 'cases-AdultGeneralConsultation'
    },
    {
        id: uuidv7(),
        name: 'cases-AdultGeneralConsultation'
    },
    {
        id: uuidv7(),
        name: 'cases-ChildGeneralConsultation'
    },
    {
        id: uuidv7(),
        name: 'cases-Toxicology'
    },
    {
        id: uuidv7(),
        name: 'cases-GeneralPractitionerDoctor'
    },
    {
        id: uuidv7(),
        name: 'cases-PediatricianDoctor'
    },
    {
        id: uuidv7(),
        name: 'cases-PoisonsDoctor'
    }
];

export const notificationGroups: INotificationGroup[] = [...casesNotificationGroups];

export const adminNotificationGroups: INotificationGroup[] = [casesNotificationGroups.find(x => x.name == 'cases')!];
